module.exports = __webpack_public_path__ + "img/2020_12_22_elf.5efdc919.jpg";